import { render, staticRenderFns } from "./scoreDt.vue?vue&type=template&id=91f76ba2&scoped=true&"
import script from "./scoreDt.vue?vue&type=script&lang=js&"
export * from "./scoreDt.vue?vue&type=script&lang=js&"
import style0 from "./scoreDt.vue?vue&type=style&index=0&id=91f76ba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f76ba2",
  null
  
)

export default component.exports